import { Box, colors, TextField, Typography, useTheme } from "@mui/material";
import React, { useState } from "react";
import { keyframes } from "@mui/system";
import WalletAddSVG from "../../../../../media/images/icons/wallet-add";
import CustomButton from "../../../../components/CustomButton";
import ArrowLeftSVG from "../../../../../media/images/icons/arrow-left";
import { addCommas } from "@persian-tools/persian-tools";
import { useFormik } from "formik";
import PriceItem from "./PriceItem";
import GatewayItem from "./GatewayItem";
import * as yup from "yup";
import useSWRMutation from "swr/mutation";
import { useAppDispatch } from "../../../../../hooks/useRedux";
import { fetcherPost } from "../../../../../services/fetcher";
import {
  setOpenSnackbar,
  setSnackbarDescription,
  setSnackbarErrorStatus,
} from "../../../../../redux/features/snackbarSlice";
import PaymentModal from "../PaymentModal";

export interface IPriceItem {
  id?: number;
  value?: number;
  checked?: boolean;
}

const scale = keyframes`
  from {
    scale: 0;
  }
  to {
    scale: 1;

  }
`;
interface Props {
  handleTransactionsList: React.Dispatch<React.SetStateAction<boolean>>;
}
export default function ChargeWalletBox(props: Props) {
  const { handleTransactionsList } = props;
  const theme = useTheme();

  const [chargeAmount, setChargeAmount] = useState("");
  const [priceValue, setPriceValue] = useState("");

  const dispatch = useAppDispatch();

  const [paymentModal, setPaymentModla] = useState(false);
  const [paymentState, setPaymentState] = useState(false);

  const [trackData, setTrackData] = useState<{
    link: string;
    code: string;
    amount: string;
  }>();

  const chargeAmountFormik = useFormik({
    initialValues: {
      amount: 0,
      gateway: 5,
      isPayInSalon: false,
    },
    validationSchema: yup.object().shape({
      amount: yup.string().required("این فیلد الزامی است!"),
    }),
    onSubmit: (values) => {
      postChargeWalletTrigger(values);

      console.log(values);
    },
  });

  const [pricesItems, setPricesItems] = useState<IPriceItem[]>([
    {
      id: 1,
      value: 10000000,
      checked: false,
    },
    {
      id: 2,
      value: 30000000,
      checked: false,
    },
    {
      id: 3,
      value: 50000000,
      checked: false,
    },
    {
      id: 4,
      value: 100000000,
      checked: false,
    },
  ]);

  const handleChangePrice = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    let { value } = e.target;
    if (value.startsWith("0") && value.length > 1 && value[1] !== ".") {
      value = value.slice(1);
    }
    const numericValue = value.replace(/[^\d]/g, ""); // Remove non-numeric characters
    const formattedValue = addCommas(numericValue); // Format the value with commas
    chargeAmountFormik.setFieldValue("amount", Number(numericValue)); // Update Formik's field value
    setPriceValue(formattedValue);
    setChargeAmount(formattedValue);
    // setPriceWord(numberToWords(String(Math.trunc(Number(numericValue) / 10))));
  };

  const handleSelectPrice = (id?: number) => {
    setPricesItems((prev: IPriceItem[]) => {
      return prev.map((item) => {
        if (item.id === id) {
          const checked = !item.checked;
          if (checked) {
            setPriceValue(addCommas(item.value?.toString()!));
            setChargeAmount(item.value?.toString()!);
            chargeAmountFormik.setFieldValue("amount", item.value!);
          }
          return { ...item, checked: checked };
        } else {
          return { ...item, checked: false };
        }
      });
    });
  };

  const {
    trigger: postChargeWalletTrigger,
    isMutating: isgetLastTenderOfferMutting,
  } = useSWRMutation(
    [`/Invoice/CreateInvoice`, localStorage.getItem("access_token")],
    fetcherPost,
    {
      onSuccess: (data) => {
        setPaymentModla(true);
        setTrackData(data);
      },
    }
  );
  return (
    <>
      <PaymentModal
        amount={addCommas(chargeAmount)}
        link={trackData?.link}
        open={paymentModal}
        paymentState={paymentState}
        setPaymentState={setPaymentState}
        trackCode={trackData?.code}
        setOpen={setPaymentModla}
      />

      <Box
        sx={{
          backgroundColor: theme.palette.bgColor.white,
          borderRadius: "16px",
          // scale: show ? 1 : 0,
          border: "1px solid",
          borderColor: colors.blueGrey[100],
          mt: 3,
          // transition: "scale 0.3s",
          animation: `${scale} 0.3s ease`,
          padding: "10px",
        }}
      >
        <Box
          sx={{
            boxShadow: "0px 0px 8px 0px rgba(0,0,0,0.1) inset",
            //   border: "1px solid gray",
            backgroundColor: theme.palette.bgColor.grey100,
            borderRadius: "10px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingY: "12px",
          }}
        >
          <WalletAddSVG size={22} color={theme.palette.secondary.main} />
          <TextField
            name="chargeAmount"
            type="text"
            placeholder="مبلغ شارژ حساب را وارد کنید"
            size="small"
            inputProps={{
              inputMode: "numeric",
              pattern: "[1-9]*",
            }}
            value={priceValue}
            onChange={(e) => handleChangePrice(e)}
            sx={{
              "& .MuiOutlinedInput-notchedOutline": {
                border: "none !important",
                outline: "none !important",
              },
              "& input::placeholder": {
                fontSize: "12px",
                direction: "ltr",
              },

              "& .MuiInputBase-input": {
                direction: "ltr",
                fontSize: "18px",
                border: "none !important",
                padding: "0px",
                outline: "none !important",
                minWidth: "200px",
                textAlign: "center",
              },
              "& .MuiInputBase-root": {
                border: "none !important",
                outline: "none !important",
              },
              border: "none",
            }}
          />
          <Typography>ریال</Typography>
        </Box>

        <Typography
          noWrap
          sx={{
            mt: 2,
            fontSize: "14px",
          }}
        >
          دسترسی راحت:
        </Typography>
        <Box
          sx={{
            flexDirection: "row-reverse",
            display: "flex",
            flexWrap: "wrap",
            alignItems: "center",
            justifyContent: "end",
            gap: "8px",
          }}
        >
          {pricesItems.map((item) => (
            <PriceItem priceItem={item} handleSelectPrice={handleSelectPrice} />
          ))}
        </Box>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography
            noWrap
            sx={{
              fontSize: "14px",
            }}
          >
            درگاه بانک انتخابی:
          </Typography>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <GatewayItem
              checked={chargeAmountFormik.values.gateway === 5}
              handleCheck={(id) =>
                chargeAmountFormik.setFieldValue("gateway", id)
              }
              id={5}
            />
          </Box>
        </Box>

        <Box></Box>

        <Box
          sx={{
            mt: 2,
            display: "flex",
            flexDirection: "column",
            gap: "8px",
          }}
        >
          {/* <Box
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
            }}
          >
            <Typography>معادل:</Typography>
            <Typography color={"primary.main"}>
              {addCommas(priceValue || "0")}
            </Typography>
            <Typography>تومان</Typography>
          </Box> */}

          {/* <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: "4px",
          }}
        >
          <Typography>کد تخفیف دارید؟</Typography>
          <Button
            onClick={() => toggleBox()}
            sx={{
              flex: "1",
              display: "flex",
              borderRadius: "6px",
              alignItems: "center",
              border: "1px solid gray",
              minWidth: "0px !important",
              height: "fit-content",
              padding: "10px 8px",
              gap: "4px",
              borderColor: `${theme.palette.primary.main} !important`,
              backgroundColor: `${theme.palette.primary.main} !important`,
              "& .MuiTouchRipple-root": {
                color: `#fff !important`,
                borderWidth: "0px !important",
              },
              "& .MuiButtonBase-root": {
                color: `${theme.palette.error.main} !important`,
                borderWidth: "0px !important",
                minWidth: "0px !important",
              },
              "& .MuiButton-root": {
                minWidth: "0px !important",
              },
            }}
          >
            <Typography
              sx={{
                color: "#fff",
                fontSize: "12px",
                whiteSpace: "nowrap",
              }}
            >
              وارد کردن کد تخفیف{" "}
            </Typography>
          </Button>
        </Box> */}
        </Box>
        <Box
          sx={{
            mt: 2,
            display: "flex",
            gap: "8px",
          }}
        >
          <CustomButton
            onClick={() => handleTransactionsList(true)}
            title="تراکنش ها"
            textColor="error.main"
            bgColor="error.light"
            justifyContent="center"
            borderColor="error.main"
            px="10px"
            py="10px"
            borderRadius="6px"
          />
          <CustomButton
            loading={isgetLastTenderOfferMutting}
            onClick={chargeAmountFormik.handleSubmit}
            // onClick={() => }
            flex={1}
            fWeight="700"
            title="تایید و پرداخت"
            bgColor="success.main"
            justifyContent="center"
            px="6px"
            py="4px"
            borderRadius="6px"
            icon2={<ArrowLeftSVG color="#fff" />}
          />
        </Box>
      </Box>
    </>
  );
}
